module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dedicated-solutions-filter"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Цена за месяц, ₽")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-fields"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-field"
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.fakeRanges.PRICE[0]
    },
    on: {
      "change": function($event) {
        return _vm.setRange('PRICE', 0, $event.target.value, true)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field"
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.fakeRanges.PRICE[1]
    },
    on: {
      "change": function($event) {
        return _vm.setRange('PRICE', 1, $event.target.value, true)
      }
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Процессор")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-checkbox-fields"
  }, _vm._l((_vm.getSorted(_vm.components.CPU)), function(processor) {
    return _c('div', {
      key: processor.ID,
      staticClass: "dedicated-solutions-choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.CPU),
        expression: "selected.CPU"
      }],
      attrs: {
        "id": processor.ID,
        "type": "checkbox"
      },
      domProps: {
        "value": processor.ID,
        "checked": Array.isArray(_vm.selected.CPU) ? _vm._i(_vm.selected.CPU, processor.ID) > -1 : (_vm.selected.CPU)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected.CPU,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = processor.ID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selected, "CPU", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selected, "CPU", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selected, "CPU", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": processor.ID
      }
    }, [_c('span', {
      staticClass: "dedicated-solutions-choice-checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "dedicated-solutions-choice-value"
    }, [_vm._v(_vm._s(processor.NAME))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Частота процессора, ГГц")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-fields"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-field"
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.fakeRanges.CPU_FREQUENCY[0]
    },
    on: {
      "change": function($event) {
        return _vm.setRange('CPU_FREQUENCY', 0, $event.target.value, true)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field"
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.fakeRanges.CPU_FREQUENCY[1]
    },
    on: {
      "change": function($event) {
        return _vm.setRange('CPU_FREQUENCY', 1, $event.target.value, true)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper rows"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Ядра процессора")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-checkbox-fields"
  }, _vm._l((_vm.cpuValues.CORE), function(core) {
    return _c('div', {
      key: core,
      staticClass: "dedicated-solutions-choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.CPU_CORE),
        expression: "selected.CPU_CORE"
      }],
      attrs: {
        "id": 'cpu-core-' + core,
        "type": "checkbox"
      },
      domProps: {
        "value": core,
        "checked": Array.isArray(_vm.selected.CPU_CORE) ? _vm._i(_vm.selected.CPU_CORE, core) > -1 : (_vm.selected.CPU_CORE)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected.CPU_CORE,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = core,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selected, "CPU_CORE", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selected, "CPU_CORE", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selected, "CPU_CORE", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'cpu-core-' + core
      }
    }, [_c('span', {
      staticClass: "dedicated-solutions-choice-checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "dedicated-solutions-choice-value"
    }, [_vm._v(_vm._s(_vm.getNumeral(core, ['ядро', 'ядра', 'ядер'])))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper rows"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Оперативная память")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-checkbox-fields"
  }, _vm._l((_vm.ramValues.MEMORY), function(memory) {
    return _c('div', {
      key: memory,
      staticClass: "dedicated-solutions-choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.RAM),
        expression: "selected.RAM"
      }],
      attrs: {
        "id": 'ram-memory-' + memory,
        "type": "checkbox"
      },
      domProps: {
        "value": memory,
        "checked": Array.isArray(_vm.selected.RAM) ? _vm._i(_vm.selected.RAM, memory) > -1 : (_vm.selected.RAM)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected.RAM,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = memory,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selected, "RAM", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selected, "RAM", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selected, "RAM", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'ram-memory-' + memory
      }
    }, [_c('span', {
      staticClass: "dedicated-solutions-choice-checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "dedicated-solutions-choice-value"
    }, [_vm._v(_vm._s(memory) + " ГБ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper rows"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Тип дисков")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-checkbox-fields"
  }, _vm._l((_vm.diskTypes), function(type) {
    return _c('div', {
      key: type,
      staticClass: "dedicated-solutions-choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.HDD_TYPE),
        expression: "selected.HDD_TYPE"
      }],
      attrs: {
        "id": 'disk-type-' + type,
        "type": "checkbox"
      },
      domProps: {
        "value": type,
        "checked": Array.isArray(_vm.selected.HDD_TYPE) ? _vm._i(_vm.selected.HDD_TYPE, type) > -1 : (_vm.selected.HDD_TYPE)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected.HDD_TYPE,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = type,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selected, "HDD_TYPE", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selected, "HDD_TYPE", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selected, "HDD_TYPE", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'disk-type-' + type
      }
    }, [_c('span', {
      staticClass: "dedicated-solutions-choice-checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "dedicated-solutions-choice-value"
    }, [_vm._v(_vm._s(type))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-field-wrapper rows"
  }, [_c('span', {
    staticClass: "dedicated-solutions-filter-title"
  }, [_vm._v("Количество дисков")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-checkbox-fields"
  }, _vm._l((_vm.hddCountVariants), function(hddCount) {
    return _c('div', {
      key: hddCount,
      staticClass: "dedicated-solutions-choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.HDD_COUNT),
        expression: "selected.HDD_COUNT"
      }],
      attrs: {
        "id": 'disk-quantity-' + hddCount,
        "type": "checkbox"
      },
      domProps: {
        "value": hddCount,
        "checked": Array.isArray(_vm.selected.HDD_COUNT) ? _vm._i(_vm.selected.HDD_COUNT, hddCount) > -1 : (_vm.selected.HDD_COUNT)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected.HDD_COUNT,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = hddCount,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selected, "HDD_COUNT", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selected, "HDD_COUNT", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selected, "HDD_COUNT", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'disk-quantity-' + hddCount
      }
    }, [_c('span', {
      staticClass: "dedicated-solutions-choice-checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "dedicated-solutions-choice-value"
    }, [_vm._v(_vm._s(hddCount))])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dedicated-solutions-filter-block-range"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-range price"
  }), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-range-values"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-range-min"
  }), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-range-max"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dedicated-solutions-filter-block-range"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-range cpu_freequency"
  }), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-range-values"
  }, [_c('div', {
    staticClass: "dedicated-solutions-filter-range-min"
  }), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-filter-range-max"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c3cdbc1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c3cdbc1!./~/vue-loader/lib/selector.js?type=template&index=0!./depohost.ru/local/vue.js/v-dedicated-solutions-filter/v-dedicated-solutions-filter.vue
// module id = 24
// module chunks = 0